export default "__VITE_ASSET__8eUW$IYM__"